<template>
    <div class="login-page">
      <div class="header">
        <img src="@/assets/logo.png" alt="Logo" class="logo" />
        <a href="#" class="help-link">Need help?</a>
      </div>
      <div class="main-content">
        <div class="background-image">
          <img src="@/assets/lawandregulation.png" alt="Background" class="background" />
        </div>
        <div class="login-box">
          <h2 class="login-title">Log In</h2>
          <button class="qr-login-btn">
            Log in with QR
            <i class="fas fa-qrcode"></i>
          </button>
          <form @submit.prevent="handleLogin" class="login-form">
            <input
              type="text"
              placeholder="Phone number / Username / Email"
              v-model="username"
              required
            />
            <input
              type="password"
              placeholder="Password"
              v-model="password"
              required
            />
            <button type="submit" class="login-btn">LOG IN</button>
            <div class="login-options">
              <a href="#" class="forgot-password">Forgot Password</a>
              <a href="#" class="phone-login">Log in with Phone Number</a>
            </div>
            <div class="social-login">
              <button class="social-btn facebook">
                <i class="fab fa-facebook"></i> Facebook
              </button>
              <button class="social-btn google">
                <i class="fab fa-google"></i> Google
              </button>
            </div>
            <a href="#" class="register-link">Register</a>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        username: '',
        password: '',
      };
    },
    methods: {
      handleLogin() {
        // Handle login logic here
        console.log('Logging in with:', this.username, this.password);
      },
    },
  };
  </script>
  
  <style scoped>
  .login-page {
    text-align: center;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
  }
  
  .logo {
    height: 50px;
  }
  
  .help-link {
    color: #004ba8;
    text-decoration: none;
  }
  
  .main-content {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f1f1f1;
  }
  
  .background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('@/assets/lawandregulation.png') no-repeat center center;
    background-size: cover;
    opacity: 0.5;
  }
  
  .login-box {
    background: #ffffff;
    padding: 20px;
    border-radius: 8px;
    width: 300px;
    z-index: 1;
  }
  
  .login-title {
    color: #ff0000;
    margin-bottom: 10px;
  }
  
  .qr-login-btn {
    background: #ffffff;
    border: 1px solid #ff0000;
    color: #ff0000;
    padding: 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  
  .login-form input {
    width: 100%;
    padding: 10px;
    margin: 5px 0;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .login-btn {
    background-color: #004ba8;
    color: #ffffff;
    padding: 10px;
    border: none;
    border-radius: 4px;
    width: 100%;
    cursor: pointer;
  }
  
  .login-options {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  }
  
  .social-login {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  
  .social-btn {
    width: 48%;
    padding: 10px;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .facebook {
    background-color: #3b5998;
    color: #ffffff;
  }
  
  .google {
    background-color: #db4437;
    color: #ffffff;
  }
  
  .register-link {
    display: block;
    margin-top: 10px;
    color: #ff0000;
    text-decoration: none;
    font-size: 14px;
  }
  </style>
  